(async () => {
    const { Core } = await importModule('Core');
    const { cartProvider } = await importModule('Utils');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    const ATTR_PREORDER = 'data-preorder';
    const ATTR_PREORDER_MSG = 'data-preorder-message';

    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }

        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick() {
            if (this._inFlight) return;
            if (this.belongsToForm) return;
            this._inFlight = true;
            this.loading = true;
            this._publishBuyWithPreview();
            this.addToCart(this.cartItems, this.mainVariantId);
        }

        _publishBuyWithPreview() {
            const items = Array.from(this.querySelectorAll('[data-buy-with-preview-item]')).map(el => ({
                image: el.dataset.image,
                url: el.dataset.url,
                title: el.dataset.title,
                isPreview: true
            }));
            if (items.length) {
                this.publish('cart-notification:preview-add', { items });
            }
        }

        addToCart(items, mainVariantId) {
            cartProvider(this)
                .add(items, mainVariantId)
        }

        _cartUpdateHandler() {
            this._inFlight = false;
            this.loading = false;
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get isPreorder() {
            return this.hasAttribute(ATTR_PREORDER)
        }

        get preorderMessage() {
            return this.getAttribute(ATTR_PREORDER_MSG) || 'Ships in 4-6 Weeks'
        }

        get mainVariantId() {
            return +this.getAttribute(ATTR_VARIANT_ID);
        }

        get cartItems() {
            const mainItem = {
                id: this.mainVariantId,
                quantity: 1
            };

            if (this.isPreorder) {
                mainItem.properties = {
                    'Shipping': this.preorderMessage
                };
            }

            return [mainItem];
        }

        get cartItem() {
            return this.cartItems;
        }

        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }
    })
})();